import { usePage } from '@inertiajs/vue3';
import { useEchoNotification } from '@laravel/echo-vue';
import { onMounted, ref } from 'vue';
import type { Auth } from '@/types';

export type UserNotification = {
    type: string;
    payload: Record<string, unknown>;
    timestamp: string;
};

const notifications = ref<UserNotification[]>([]);

let subscribed = false;

export function useUserChannel() {
    const page = usePage<{ auth: Auth }>();
    const userId = page.props.auth?.user?.id;

    onMounted(() => {
        if (!userId || subscribed) {
            return;
        }

        useEchoNotification(
            `user.${userId}`,
            (notification: Record<string, unknown>) => {
                notifications.value.unshift({
                    type: (notification.type as string) ?? 'unknown',
                    payload: notification,
                    timestamp: new Date().toISOString(),
                });
            },
        );

        subscribed = true;

        console.log('Notifications subscribed');
    });

    return { notifications };
}
